import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/indexicon/iconfont.css'
import App from './App'
import router from './router'
import store from './vuex'
import myPlug from './commons/my-plug'

import dictionaryType from './commons/dictionaryType'
import dataV from '@jiaminghi/data-view'
import AES from './utils/AES'

Vue.use(dataV)
Vue.prototype.$dictionaryType = dictionaryType // 字典类型挂载
Vue.prototype.$aes = AES

import * as echarts from 'echarts'//引入echarts
Vue.prototype.$echarts = echarts

Vue.prototype.$myPlug = myPlug

import axios from '@/http/axiosInstance.js'

Vue.prototype.$axios = axios
import http from './http/index'
Vue.use(http) // 使用http工具
// 使用element UI
Vue.use(ElementUI)

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

// console.log(obj) obj会显示...,需要重新格式 ，深考贝
window.$copy = obj => {
  return obj && typeof obj === 'object' ? JSON.parse(JSON.stringify(obj)) : obj
}

new Vue({
  el: '#app',
  router,
  store, // 使用store vuex状态管理
  components: {
    App
  },
  template: '<App/>',
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js